import { render } from "./AuditLogsImageIcon.vue?vue&type=template&id=2ba0e405&ts=true"
import script from "./AuditLogsImageIcon.vue?vue&type=script&lang=ts"
export * from "./AuditLogsImageIcon.vue?vue&type=script&lang=ts"

import "./AuditLogsImageIcon.vue?vue&type=style&index=0&id=2ba0e405&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__